import { faTriangleExclamation } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "../ui";

type Action = {
  label: string;
  onClick: () => void;
  variant?: "primary" | "tertiary";
};

type Props = {
  title?: string;
  message: string;
  actions?: Action[];
  iconColorClassName?: string;
  messageClassName?: string;
};

export function RestrictedAccessMessage({
  title,
  message,
  actions,
  iconColorClassName = "text-[var(--colour-icon-warning-bright)]",
  messageClassName = "text-lg font-normal leading-6 text-center text-[var(--colour-text-light)]",
}: Props) {
  return (
    <div className="flex items-center justify-center flex-1 bg-[var(--colour-surface-page-default)]">
      <div className="flex flex-col items-center gap-6 w-[448px] px-3">
        <div className="w-8 h-8 inline-flex justify-center items-center">
          <FontAwesomeIcon
            icon={faTriangleExclamation}
            className={iconColorClassName}
            style={{ width: 28, height: 24 }}
            aria-hidden="true"
          />
        </div>
        <div className="flex flex-col items-center gap-2 w-full">
          {title && (
            <p className="text-xl font-medium leading-6 tracking-wide text-center text-[var(--colour-text-default)]">
              {title}
            </p>
          )}
          <p className={messageClassName}>{message}</p>
        </div>
        {actions && actions.length > 0 && (
          <div className="flex flex-row gap-4 items-center justify-center">
            {actions.map((action) =>
              action.variant === "primary" ? (
                <Button
                  key={action.label}
                  variant="solid"
                  color="primary"
                  onClick={action.onClick}
                  className="shadow-[1px_2px_6px_0px_var(--core-effects-shadow,rgba(0,0,0,0.15))]"
                >
                  {action.label}
                </Button>
              ) : (
                <Button key={action.label} variant="text" color="neutral" onClick={action.onClick}>
                  {action.label}
                </Button>
              ),
            )}
          </div>
        )}
      </div>
    </div>
  );
}
